var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriteQueryOrEmailUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.979,
    height: 23.755,
    viewBox: "0 0 28.979 23.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "write_query_or_email_us",
    transform: "translate(0.024 -46.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(21.025 52.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8615",
    "data-name": "Path 8615",
    d: "M372.684,166.455a.566.566,0,1,0-.8.8h0a.56.56,0,0,0,.4.166.567.567,0,0,0,.4-.967Z",
    transform: "translate(-371.717 -166.288)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(5.204 46.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8616",
    "data-name": "Path 8616",
    d: "M115.6,59.777l-5.253-5.253a.566.566,0,0,0-.8.8l4.171,4.17h-9.945a1.5,1.5,0,0,1-1.5-1.5V48.053l4.026,4.026a.566.566,0,0,0,.8-.8L101.99,46.17a.566.566,0,0,0-.8,0l-9.017,9.017a.566.566,0,0,0,0,.8L105.78,69.594a.566.566,0,0,0,.8,0l9.017-9.017a.566.566,0,0,0,0-.8ZM101.146,47.818v7.2h-7.2Zm4.473,20.011L93.942,56.153h7.2V58a2.63,2.63,0,0,0,2.627,2.627h1.845Zm1.131,0v-7.2h7.2Z",
    transform: "translate(-92.011 -46.004)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198",
    transform: "translate(0 57.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8617",
    "data-name": "Path 8617",
    d: "M3.882,254H.566a.566.566,0,1,0,0,1.131H3.882a.566.566,0,1,0,0-1.131Z",
    transform: "translate(0 -253.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(4.994 57.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8618",
    "data-name": "Path 8618",
    d: "M88.87,254h-.008a.566.566,0,1,0,0,1.131h.008a.566.566,0,1,0,0-1.131Z",
    transform: "translate(-88.296 -253.999)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202",
    transform: "translate(0.001 51.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8619",
    "data-name": "Path 8619",
    d: "M2.389,149H.579a.566.566,0,0,0,0,1.131h1.81a.566.566,0,0,0,0-1.131Z",
    transform: "translate(-0.013 -149.002)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204",
    transform: "translate(3.659 51.83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8620",
    "data-name": "Path 8620",
    d: "M67.387,149h-2.14a.566.566,0,0,0,0,1.131h2.14a.566.566,0,0,0,0-1.131Z",
    transform: "translate(-64.682 -149.002)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    transform: "translate(3.862 60.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8621",
    "data-name": "Path 8621",
    d: "M72.016,309H68.849a.566.566,0,0,0,0,1.131h3.167a.566.566,0,0,0,0-1.131Z",
    transform: "translate(-68.283 -308.998)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208",
    transform: "translate(1.528 64.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8622",
    "data-name": "Path 8622",
    d: "M35.55,373H27.575a.566.566,0,0,0,0,1.131H35.55a.566.566,0,0,0,0-1.131Z",
    transform: "translate(-27.009 -372.996)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteQueryOrEmailUs);
export default __webpack_public_path__ + "static/media/write_query_or_email_us.66c3b00944a2d53630520d0b56cd723d.svg";
export { ForwardRef as ReactComponent };